import React, { useEffect, useState } from "react";


export const BloqueHomeAcciones = () => {
    const [cargaOferta, setCargaOferta] = useState('');

    useEffect(() => {
        const asyncFunction = async () => {
            const endpoint = await (await fetch('/api/show_endpoints/cargaoferta')).json();

        setCargaOferta(
            `${endpoint.url_base}${endpoint.url_variable}`
        )
        }
        asyncFunction();
    }, []);

    return (
        <div className="bloqueHomeAcciones">
            <h1 className="title30">OTRAS ACCIONES</h1>
            <div className="bloqueHomeAcciones--buttons">
                <a className="btn-red" target="_blank" href={cargaOferta}>
                    <button className="mt-half"><p>OFERTA DE LICITACION</p><p><img className="ml-half" src='/images/icons/small.svg' /></p></button>
                </a>
                <a className="btn-red" target="_blank" href="https://crmfcalatam.my.site.com/selfservicepda/s/submit-request-fiat-fin-de-grupo">
                    <button className="mt-half"><p>SOLICITUD DE REINTEGRO</p><p><img className="ml-half" src='/images/icons/small.svg' /></p></button>
                </a>
            </div>
        </div>
    )
}
